module.exports = __webpack_public_path__ + "static/media/icon4.79d7a315.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon4.png
// module id = 1766
// module chunks = 0 1